<template>
  <div>
    <!-- error message -->
    <v-alert v-if="attachmentError" dismissible dense class="mx-1" type="error">
      {{ attachmentError }}
    </v-alert>
    <!-- Preview when only One Attachment Selected -->
    <div
      v-if="selectedAttachments.length && selectedAttachments.length == 1"
      class="d-flex justify-center"
    >
      <v-card
        class="float-left rounded my-1 mx-1"
        color="white"
        width="185"
        :height="
          selectedAttachments[0].type == 'image/png' ||
          selectedAttachments[0].type == 'image/jpg' ||
          selectedAttachments[0].type == 'image/jpeg' ||
          selectedAttachments[0].type == 'video/mp4' ||
          selectedAttachments[0].type == 'video/webm'
            ? '150'
            : '80'
        "
      >
        <v-app-bar
          height="10"
          flat
          color="rgba(0, 0, 0, 0)"
          v-if="
            selectedAttachments[0].type == 'video/mp4' ||
              selectedAttachments[0].type == 'video/webm'
          "
        >
          <v-spacer></v-spacer>
          <v-icon
            @click="deleteImage(selectedAttachments[0])"
            class="pointer dlt-icon"
            color="red"
            >mdi-delete</v-icon
          >
        </v-app-bar>
        <video
          :src="selectedAttachments[0].file"
          controls
          width="180"
          height="130"
          class="pt-1"
          v-if="
            selectedAttachments[0].type == 'video/mp4' ||
              selectedAttachments[0].type == 'video/webm' ||
              selectedAttachments[0].type == 'video/mov'
          "
        ></video>
        <!-- preview for images -->
        <v-img
          v-else-if="
            selectedAttachments[0].type == 'image/png' ||
              selectedAttachments[0].type == 'image/jpg' ||
              selectedAttachments[0].type == 'image/jpeg'
          "
          height="150"
          :src="selectedAttachments[0].file"
        >
          <v-app-bar height="10" flat color="rgba(0, 0, 0, 0)">
            <v-spacer></v-spacer>
            <v-icon
              @click="deleteImage(selectedAttachments[0])"
              class="pointer dlt-icon red--text"
              >mdi-delete</v-icon
            >
          </v-app-bar>
        </v-img>

        <span v-else>
          <v-app-bar height="10" flat color="rgba(0, 0, 0, 0)">
            <v-spacer></v-spacer>
            <v-icon
              @click="deleteImage(selectedAttachments[0])"
              class="pointer dlt-icon"
              color="red"
              >mdi-delete</v-icon
            >
          </v-app-bar>
          <!-- preview for another file  -->
          <v-layout fill-height>
            <FileSVG :extension="selectedAttachments[0].extention" />
          </v-layout>
          <v-layout class="text-center mt-n15">
            <v-card
              color="transparent"
              flat
              class="my-n3 col-12 ml-n3 text-truncate"
            >
              <p class="ml-12 text-center subtitle-2 black--text d-inline">
                {{ selectedAttachments[0].name }}
              </p>
            </v-card>
          </v-layout>
        </span>
      </v-card>
    </div>
    <!-- Preview when more than one Attachment Selected -->
    <div
      v-show="selectedAttachments.length && selectedAttachments.length > 1"
      class="fileContainer mx-1 mb-2"
      style="margin-top: 3px; text-align: center; overflow-y: scroll;pointer"
    >
      <div>
        <v-file-input
          ref="uploader"
          id="my_input"
          filled
          multiple
          v-model="selectedFiles"
          @change="previewFiles"
          class="d-none float-right"
        ></v-file-input>

        <!-- Display Image Preview -->
        <v-card
          class="float-left rounded my-1 mx-1"
          color="white"
          v-for="(item, i) in selectedAttachments"
          :key="item.id"
          v-show="i <= 2"
          width="62"
          height="70"
        >
          <!-- preview for images -->
          <v-img
            v-if="
              item.type == 'image/png' ||
                item.type == 'image/jpg' ||
                item.type == 'image/jpeg'
            "
            height="70"
            :src="item.file"
          >
            <v-app-bar height="10" flat color="rgba(0, 0, 0, 0)">
              <v-spacer></v-spacer>
              <v-icon
                @click="deleteImage(item)"
                class="pointer ml-8 mt-1 red--text"
                small
                >mdi-delete</v-icon
              >
            </v-app-bar>
          </v-img>

          <span v-else>
            <v-app-bar height="10" flat color="rgba(0, 0, 0, 0)">
              <v-spacer></v-spacer>
              <v-icon
                @click="deleteImage(item)"
                class="pointer ml-8 mt-1"
                color="red"
                small
                >mdi-delete</v-icon
              >
            </v-app-bar>
            <FileSVG :extension="item.extention" />
          </span>
        </v-card>
        <!-- Preview when more than three Attachment Selected -->
        <div
          v-if="selectedAttachments.length > 3"
          style="padding-top: 25px"
          class="d-flex"
        >
          <span class="white--text caption">
            (+{{ selectedAttachments.length - 3 }} others)
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileSVG from "../../../assets/svgs/FileSVG";
import { eventBus } from "@/main";
export default {
  props: ["selectedAttachments"],

  data() {
    return {
      noComments: null,
      attachmentError: "",
      selectedFiles: [],
    };
  },
  components: {
    FileSVG,
  },
  created() {
    if (this.showContainer == true) {
      this.showAttachemntsContainer();
    }
  },
  methods: {
    containerclick() {
      let element = document.getElementById("my_input");
      element.click();
    },
    showAttachemntsContainer() {
      this.noComments = false;
    },
    previewFiles(files) {
      this.attachmentError = "";
      this.numFiles = 0;
      this.filesSize = 0;

      // if file size exceeds max limit
      if (files.length > 5) {
        this.attachmentError = "You cannot select more than 5 files at a time";
        if (!this.selectedAttachments.length) {
          eventBus.$emit("showSelectedAttachmentsError", this.attachmentError);
        }
        setTimeout(() => {
          this.attachmentError = "";
        }, 2000);
        return;
      }

      for (let i = 0; i < files.length; i++) {
        if (files[i].size > 150000000) {
          this.attachmentError = "File Size can not be more than 150MB";
          if (!this.selectedAttachments.length) {
            eventBus.$emit(
              "showSelectedAttachmentsError",
              this.attachmentError
            );
          }
          setTimeout(() => {
            this.attachmentError = "";
          }, 2000);
          return;
        }
        this.getBase64(files[i]).then((data) => {
          this.attachmentError = "";
          this.numFiles = files.length;
          var body = {
            id: Math.random()
              .toString(36)
              .substr(2, 5),
            name: files[i].name,
            type: files[i].type,
            extention: files[i].name.split(".").pop(),
            file: data,
          };
          eventBus.$emit("updateSelectedAttachmentsCopy", body);
        });
        eventBus.$emit("addSelectedAttachments", files[i]);
        this.selectedFiles = [];
      }

      setTimeout(() => {
        this.attachmentError = "";
      }, 2000);
    },

    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    deleteImage(item) {
      eventBus.$emit("deleteSelectedAttachment", item);
    },
    triggerInputClick() {
      let my_input = document.getElementById("my_input");
      my_input.click();
    },
  },

  mounted() {
    eventBus.$on("openChooseFileModal", () => {
      let my_input = document.getElementById("my_input");
      my_input.click();
    });
  },
  beforeDestroy() {
    eventBus.$off("openChooseFileModal");
  },
};
</script>

<style scoped>
/* file uplaod attachment */
.fileContainer {
  overflow: hidden;
  position: relative;
  font-size: 12px;
  height: 90px;
  border-radius: 3px;
  background-color: rgb(255, 246, 246) !important;
  background-color: rgba(56, 56, 56, 0.8) !important;
  -webkit-backdrop-filter: transparent(4px);
  backdrop-filter: transparent(4px);
  padding-top: 6px;
}
.pdf-style.mdi-file-pdf::before {
  margin-top: 35px;
}
.word-file.mdi-microsoft-word::before {
  margin-top: 35px;
}
.dlt-icon.mdi-delete::before {
  margin-top: 13px;
  margin-right: -17px;
  background-color: transparent !important;
}
.video-icon.mdi-movie-open-play::before {
  margin-top: 35px;
}
.gif-icon.mdi-gif::before {
  margin-top: 35px;
}
.paperclip-style.mdi-paperclip::before {
  margin-left: -10px;
  margin-bottom: 10px;
}
</style>
